import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

/**
 * Validator that enforces the password strength policy:
 *  - Between 8 and 50 characters
 *  - At least one uppercase letter
 *  - At least one lowercase letter
 *  - At least one digit
 *  - At least one special character
 */
export function strongPasswordValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const value: string = control.value ?? '';
    if (!value) return null; // let `required` handle empty

    const errors: ValidationErrors = {};

    if (value.length < 8) errors['minlength'] = { requiredLength: 8, actualLength: value.length };
    if (value.length > 50) errors['maxlength'] = { requiredLength: 50, actualLength: value.length };
    if (!/[A-Z]/.test(value)) errors['missingUppercase'] = true;
    if (!/[a-z]/.test(value)) errors['missingLowercase'] = true;
    if (!/\d/.test(value)) errors['missingDigit'] = true;
    if (!/[^A-Za-z0-9]/.test(value)) errors['missingSpecial'] = true;

    return Object.keys(errors).length ? errors : null;
  };
}
